import React, { useState } from 'react'
import moment from 'moment'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'

const ShowAvailability = ({
  data,
  specificNeeds,
  addSession,
  availabilityPercentages,
  bookMultipleSessions,
  selectedTimeSlot,
  setSelectedTimeSlot,
  claimData,
  setBookSession,
  startDate,
  endDate,
}) => {
  const [selectedSlots, setSelectedSlots] = useState([])
  const totalSelected = selectedSlots.length
  const remainingSessions =
    claimData.session_count - claimData.used_sessions.length
  const clearSelectedSlots = () => {
    setSelectedTimeSlot({})
    setSelectedSlots([])
  }

  const axios = useAxiosPrivate()

  const { auth, setShowLoader, createInfo } = useAuth()

  const [numberOfSessions, setNumberOfSessions] = useState(remainingSessions)

  let hasSpeciality = []
  if (data.user.specialities.length > 0) {
    specificNeeds.forEach((need) => {
      if (
        data.user.specialities.some((speciality) => {
          return speciality.id === need.id
        })
      ) {
        hasSpeciality++
      }
    })
  }

  const handleSlotSelect = (date, slot) => {
    let newSlots = []
    if (bookMultipleSessions) {
      newSlots.push(slot)
      let runningDate = slot
      for (let i = 1; i < numberOfSessions; i++) {
        runningDate = moment(runningDate, 'YYYY-MM-DD HH:mm:ss')
          .add(7, 'days')
          .format('YYYY-MM-DD HH:mm:ss')
        if (data.slots.includes(runningDate)) {
          newSlots.push(runningDate)
        } else {
          createInfo(
            'error',
            'Not enough slots available, ' +
            (i - 2) +
            '/' +
            numberOfSessions +
            ' slots selected'
          )
          // newSlots = []
        }
      }
    }

    setSelectedSlots(newSlots)
  }

  const isLimitReached = totalSelected >= numberOfSessions

  const addMultipleSessions = async (data) => {
    setShowLoader(true)

    let sessionDataArray = selectedSlots.map((session) => {
      let formattedDay = moment(session).format('YYYY-MM-DD')
      let formattedTime = moment(session).format('HH:mm')

      return {
        date: formattedDay,
        start: formattedTime,
        end: moment(formattedTime, 'HH:mm')
          .add(claimData.service.default_length, 'minutes')
          .format('HH:mm'),
        user: data.user,
        service: claimData.service,
      }
    })

    try {
      const response = await axios.post(
        `/claims/${claimData.id}/sessions/add-multiple`,
        { sessions: sessionDataArray }
      )

      if (!response.data.error) {
        setBookSession(false)
        setSelectedSlots([])

        window.location.reload()
      }

      if (response.data.error) {
        createInfo('error', response.data.message)
      }
    } catch (error) {
      console.error('Error adding multiple sessions:', error)
      createInfo('error', 'An error occurred while booking sessions.')
    }

    setShowLoader(false)
  }

  const getSelectedSlot = (key) => {
    let returnData = 0
    selectedSlots.forEach((slot) => {
      let day = moment(slot, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
      if (day === key) {
        for (const timeSlot of data.days[key]) {
          if (timeSlot === slot) {
            returnData = timeSlot
            break
          }
        }
      }
    })
    return returnData
  }

  const RenderOccuringDays = () => {
    let divider = false
    const render = Object.keys(data?.days || {}).map((key, index) => {
      if (key.includes('-parent')) {
        divider = true
        return null
      }
      if (divider) {
        //check if key falls between startDate and endDate
        if (
          moment(key, 'DD/MM/YYYY').isBetween(
            moment(startDate).subtract(1, 'days'),
            moment(endDate).add(1, 'days')
          )
        ) {
          divider = false
          return (
            <div key={index} className="w-[300px] relative mr-4">
              <h3 className="font-medium mb-1 text-sm">
                {moment(key, 'DD/MM/YYYY').format('dddd Do MMMM')}
              </h3>
              <div>
                <label
                  htmlFor="service"
                  className="block font-medium text-gray-600 text-sm"
                >
                  Time Slot
                </label>
                <select
                  value={getSelectedSlot(key)}
                  className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  required
                  onChange={(e) => handleSlotSelect(key, e.target.value)}
                  disabled={isLimitReached}
                  id="service"
                >
                  <option disabled value={0}>
                    Select a Time
                  </option>
                  {data.days[key].map((slot, index) => {
                    return (
                      <option key={index} value={slot}>
                        {moment(slot).format('HH:mm a')}
                      </option>
                    )
                  })}
                </select>
              </div>
            </div>
          )
        } else {
          return null
        }
      } else {
        return null
      }
    })
    return render
  }

  return (
    <div className="p-4 rounded-md border border-slate-300 mt-4">
      {bookMultipleSessions ? (
        <>
          <div className="flex">
            {data.user.video_sessions === 1 && (
              <div className="group w-7 h-7 fill-slate-800 cursor-pointer relative mr-2 z-10">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" />
                </svg>
                <span
                  className={`absolute top-8 scale-0 transition-all font-normal rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100 -left-7 min-w-[300px]`}
                >
                  This practitioner does video sessions
                </span>
              </div>
            )}
            {hasSpeciality > 0 && (
              <div className="group w-7 h-7 fill-yellow-500 cursor-pointer relative mr-2 z-10">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z" />
                </svg>
                <span
                  className={`absolute top-8 scale-0 transition-all font-normal rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100 -left-7 min-w-[300px]`}
                >
                  This practitioner has {hasSpeciality} matching{' '}
                  {hasSpeciality === 1 ? 'speciality' : 'specialities'}
                </span>
              </div>
            )}
            <div className="font-bold text-lg mb-2 flex space-x-1">
              <span>{data.user.name} </span>
              <div className="group w-7 h-7 cursor-pointer relative mr-2 z-10">
                <span className="text-sm">
                  {availabilityPercentages[data.user.id] != null
                    ? `  (${availabilityPercentages[data.user.id]}%)`
                    : '(N/A)'}
                </span>
                <span
                  className={`absolute top-8 scale-0 transition-all text-center font-normal rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100 -left-7 min-w-[200px]`}
                >
                  Percentage booked
                </span>
              </div>
            </div>
          </div>

          <div className="mb-2">
            <label
              htmlFor="service"
              className="block font-medium text-gray-600 text-sm"
            >
              Number of Sessions to book
            </label>
            <input
              className="border border-gray-300 rounded-md shadow-md px-2 py-2 block w-full max-w-[200px]"
              type="number"
              value={numberOfSessions}
              onChange={(e) => {
                if (e.target.value > remainingSessions) {
                  setNumberOfSessions(remainingSessions)
                  createInfo(
                    'error',
                    'Number of sessions cannot exceed remaining sessions'
                  )
                  return
                } else {
                  setSelectedSlots([])
                  setNumberOfSessions(e.target.value)
                }
              }}
            />
          </div>

          <div className="flex flex-wrap space-y-1">
            <RenderOccuringDays />
          </div>

          <button
            className={`btn green mt-4 ${selectedSlots.length === 0 &&
              'cursor-not-allowed pointer-events-none opacity-50'
              }`}
            onClick={() => {
              addMultipleSessions(data)
            }}
          >
            Add Multiple Sessions ({totalSelected}/{numberOfSessions})
          </button>
          <button
            className={`btn ml-2 ${selectedSlots.length === 0
                ? 'grey cursor-not-allowed pointer-events-none opacity-80'
                : 'red hover:bg-red-700'
              } `}
            onClick={clearSelectedSlots}
            disabled={selectedSlots.length === 0}
          >
            Clear Selection
          </button>
        </>
      ) : (
        <>
          <div className="flex">
            {data.user.video_sessions === 1 && (
              <div className="group w-7 h-7 fill-slate-800 cursor-pointer relative mr-2 z-10">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z" />
                </svg>
                <span
                  className={`absolute top-8 scale-0 transition-all font-normal rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100 -left-7 min-w-[300px]`}
                >
                  This practitioner does video sessions
                </span>
              </div>
            )}
            {hasSpeciality > 0 && (
              <div className="group w-7 h-7 fill-yellow-500 cursor-pointer relative mr-2 z-10">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z" />
                </svg>
                <span
                  className={`absolute top-8 scale-0 transition-all font-normal rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100 -left-7 min-w-[300px]`}
                >
                  This practitioner has {hasSpeciality} matching{' '}
                  {hasSpeciality === 1 ? 'speciality' : 'specialities'}
                </span>
              </div>
            )}
            <div className="font-bold text-lg mb-2 flex space-x-1">
              <span>{data.user.name} </span>
              <div className="group w-7 h-7 cursor-pointer relative mr-2 z-10">
                <span className="text-sm">
                  {availabilityPercentages[data.user.id] != null
                    ? `  (${availabilityPercentages[data.user.id]}%)`
                    : '(N/A)'}
                </span>
                <span
                  className={`absolute top-8 scale-0 transition-all text-center font-normal rounded bg-gray-800 p-2 text-sm text-white group-hover:scale-100 -left-7 min-w-[200px]`}
                >
                  Percentage booked
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap space-y-1">
            {Object.keys(data?.days || {}).map((key, index) => {
              return (
                <div key={index} className="w-[300px] relative mr-4">
                  <h3 className="font-medium mb-1 text-sm">
                    {moment(key, 'DD/MM/YYYY').format('dddd Do MMMM')}
                  </h3>
                  <div>
                    <label
                      htmlFor="service"
                      className="block font-medium text-gray-600 text-sm"
                    >
                      Time Slot
                    </label>
                    <select
                      defaultValue={
                        selectedTimeSlot[data.user.name] &&
                          selectedTimeSlot[data.user.name][key]
                          ? selectedTimeSlot[data.user.name][key]
                          : 0
                      }
                      className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                      required
                      onChange={(e) => {
                        if (!selectedTimeSlot[data.user.name]) {
                          selectedTimeSlot[data.user.name] = {}
                        }
                        selectedTimeSlot[data.user.name][key] = e.target.value
                        setSelectedTimeSlot({ ...selectedTimeSlot })
                      }}
                      id="service"
                    >
                      <option disabled value={0}>
                        Select a Time
                      </option>
                      {data.days[key].map((slot, index) => {
                        return (
                          <option key={index} value={slot}>
                            {moment(slot).format('HH:mm a')}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                  <button
                    className="btn green mt-4"
                    onClick={() => {
                      addSession(
                        data.user,
                        key,
                        selectedTimeSlot[data.user.name][key]
                      )
                    }}
                  >
                    Add Session
                  </button>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default ShowAvailability
